import { useContext } from "react";
import { FormContext } from "../../contexts/FormContext";
import Helper from "../../util/helper";
import './FormTitle.css';
import { RenderScrollContext } from "../../contexts/RenderScrollContext";

export const FormTitle = ({ isAdvancedForm, title }) => {
  const titleValue = isAdvancedForm ? title.disableprintpdf ? '' : title.text : title;
 
  const { isHTML, getScreenDimensions } = useContext(FormContext);
  const { calculateWidthPercentageOfPage, getPageWidth, getPageHeight } = useContext(RenderScrollContext);
  
  const getTitleStyles = () => {
    const { fontFamily, fontSize } = getScreenDimensions();

    const { posx, posy, sizex, page } = title.position;
    const pageWidth = getPageWidth(page - 1);
    const pageHeight = getPageHeight(page - 1);
    const percentage = calculateWidthPercentageOfPage(page - 1);
    return Helper.getElementPositionStyles(posx, posy, sizex, fontFamily, '', pageWidth, pageHeight, percentage, false, fontSize);
  }

  return isHTML ? (
    <div
      style={isAdvancedForm ? getTitleStyles() : {}}
      className={`${isAdvancedForm ? 'advanced-form' : ''} form-section-title`}
      dangerouslySetInnerHTML={Helper.mapInnerHtmlData(titleValue)}
    />
  ) : (
    <div style={isAdvancedForm ? getTitleStyles() : {}} className={`${isAdvancedForm ? 'advanced-form' : ''} form-section-title`}>
      {titleValue}
    </div>
  );
};
